import { Link, useNavigate } from 'react-router-dom'
import { type PropsWithChildren } from 'react'

interface Props {
    hasBackButton?: boolean
}

const OrderLayout: React.FC<PropsWithChildren<Props>> = ({
    children,
    hasBackButton,
}) => {
    const navigate = useNavigate()
    const handleBackToCreateOrderPage = () => {
        navigate('/create-order')
    }
    return (
        <div>
            <div className="container relative mx-auto hidden h-[77px] w-full items-center justify-center md:flex">
                {hasBackButton && (
                    <button
                        className="absolute left-0 flex items-center"
                        onClick={handleBackToCreateOrderPage}
                    >
                        <img src="/images/arrow-left.png" alt="arrow-left" />
                    </button>
                )}
                <Link to="/">
                    <img
                        src="/images/logo.png"
                        alt="logo"
                        className="h-10 w-[166px]"
                    />
                </Link>
            </div>
            <div className="min-h-[calc(100vh-77px)] bg-[#F6F6FB] md:pt-9">
                {children}
            </div>
        </div>
    )
}

export default OrderLayout
